import {NetworkBasicState} from '@fantasmagames/slot/src/modules/network/states/NetworkBasicState';
import {Action} from '@fantasmagames/slot/src/logic/Action';

export class GameNetworkBasicState extends NetworkBasicState {
	protected setupEvents(): void {
		super.setupEvents();
	}

	protected onPick(): void {
		this.module.logic.pick(null);
	}

	protected onSkipPick(): void {
		this.module.logic.skippick(null);
	}

	protected onReelsSpinningStarted(): void {
		switch (this.module.logic.nextAction) {
			case Action.SPIN:
				this.module.logic.spin(null);
				break;
			case Action.FREESPIN:
				this.module.logic.freespin(null);
				break;

			default:
				break;
		}
	}
}



// WEBPACK FOOTER //
// ./src/network/states/GameNetworkBasicState.ts